module.exports = __webpack_public_path__ + "img/blue.f1214ff1.webp";